import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { LOCATION_STATUS } from '../../../darkmatter/GeoClosestLocation';
function renderSortingCompleteStatus() {
  return /*#__PURE__*/React.createElement("p", {
    className: "locations-filter-geostate-unavailable"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "location arrow"
  }), "Distance sorting complete");
}
function renderUserLocationUnavailableStatus() {
  return /*#__PURE__*/React.createElement("p", {
    className: "locations-filter-geostate-unavailable"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "location arrow"
  }), "Location unavailable");
}
var defaultProps = {
  loading: false
};
var SortByDistanceButton = /*#__PURE__*/function (_React$Component) {
  _inherits(SortByDistanceButton, _React$Component);
  var _super = _createSuper(SortByDistanceButton);
  function SortByDistanceButton() {
    _classCallCheck(this, SortByDistanceButton);
    return _super.apply(this, arguments);
  }
  _createClass(SortByDistanceButton, [{
    key: "renderLocationIdleStatus",
    value: function renderLocationIdleStatus() {
      var _this$props = this.props,
        loading = _this$props.loading,
        onSort = _this$props.onSort;
      return /*#__PURE__*/React.createElement(Button, {
        onClick: onSort,
        content: "Sort by distance",
        icon: "location arrow",
        basic: true,
        loading: loading
      });
    }
  }, {
    key: "render",
    value: function render() {
      var locationSortingStatus = this.props.locationSortingStatus;
      var SortButton = null;
      if (locationSortingStatus === LOCATION_STATUS.LOCATION_UNAVAILABLE) {
        SortButton = renderUserLocationUnavailableStatus();
      } else if (locationSortingStatus === LOCATION_STATUS.FINISHED) {
        SortButton = renderSortingCompleteStatus();
      } else {
        SortButton = this.renderLocationIdleStatus();
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-filter-geostate-label"
      }, SortButton);
    }
  }]);
  return SortByDistanceButton;
}(React.Component);
export { SortByDistanceButton as default };
SortByDistanceButton.defaultProps = defaultProps;